<template>
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>未読/既読</label>
        <dropdown v-model="searchForm.model.unread" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
          <option value="true">未読</option>
        </dropdown>
      </div>
      <div class="field">
        <label>担当者</label>
        <dropdown v-model="searchForm.model.assignee" :options="consts.CONCIERGE_MEMBERS" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
          <option value="none">なし</option>
        </dropdown>
      </div>
      <div class="field">
        <label>ステータス</label>
        <dropdown v-model="searchForm.model.status" :options="consts.MARUNAGE_STATUS" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
        </dropdown>
      </div>
      <div class="field">
        <label>空席確認</label>
        <dropdown v-model="searchForm.model.has_like" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
          <option value="true">あり</option>
        </dropdown>
      </div>
      <div class="field">
        <label>希望日</label>
        <datepick v-model="searchForm.model.event_date" :placeholder="'希望日'" @change="search()"></datepick>
      </div>
    </div>
    <div class="fields">
      <div class="field">
        <label>宴会ID / 申込者名 / TEL / メールアドレス/ 担当者メモ / 予約依頼番号</label>
        <div class="ui action input">
          <input type="text" v-model="searchForm.model.q" placeholder="検索条件">
          <button class="ui teal button">Search</button>
        </div>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical centered loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <div class="relative">
      <pagination :pager="pager" :callback="search"></pagination>
      <div style="display: inline-block; position: absolute; right: 0; bottom: 0;">
        <div>
          <button @click="openBanquetsDownloadDialog" type="button" class="ui small olive button"><i class="download icon"></i>店舗毎問い合わせ一覧をダウンロード</button>
          <button @click="openDownloadDialog" type="button" class="ui small yellow button"><i class="download icon"></i>CSVでダウンロードする</button>
        </div>
      </div>
      <div id="show-download-dialog" class="ui mini modal">
        <i class="close icon"></i>
        <div class="header">まるなげ情報CSVダウンロード</div>
        <div class="content">
          <form class="ui form">
            <div class="two fields">
              <div class="required field">
                <label>開始日</label>
                <datepick v-model="downloadForm.model.begin" :placeholder="'開始日'"></datepick>
              </div>
              <div class="required field">
                <label>終了日</label>
                <datepick v-model="downloadForm.model.end" :placeholder="'終了日'"></datepick>
              </div>
            </div>
          </form>
        </div>
        <div class="actions">
          <button class="ui cancel button">閉じる</button>
          <a :href="marunageDownloadLink" target="_blank">
            <button class="ui positive button">ダウンロードする</button>
          </a>
        </div>
      </div>
      <div id="show-banquets-download-dialog" class="ui mini modal">
        <i class="close icon"></i>
        <div class="header">店舗毎問い合わせ一覧CSVダウンロード</div>
        <div class="content">
          <form class="ui form">
            <div class="two fields">
              <div class="field">
                <label>開始日</label>
                <datepick v-model="banquetsDownloadForm.model.begin" :placeholder="'開始日'"></datepick>
              </div>
              <div class="field">
                <label>終了日</label>
                <datepick v-model="banquetsDownloadForm.model.end" :placeholder="'終了日'"></datepick>
              </div>
            </div>
          </form>
        </div>
        <div class="actions">
          <button class="ui cancel button">閉じる</button>
          <a :href="banquetsDownloadLink" target="_blank">
            <button class="ui positive button">ダウンロードする</button>
          </a>
        </div>
      </div>
    </div>
    <table class="ui compact table">
      <thead>
        <tr>
          <th>申込日時</th>
          <th class="center aligned">チャット</th>
          <th>担当者</th>
          <th>ステータス</th>
          <th>まるなげID</th>
          <th>空席確認</th>
          <th>TEL</th>
          <th>メールアドレス</th>
          <th>希望日時</th>
          <th>申込者名</th>
          <th>予約依頼番号</th>
          <th>デバイス</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="marunage in marunages" :key="marunage.id" :class="rowClass(marunage)">
          <td>{{ marunage.created_at | formatDatetime}}</td>
          <td class="center aligned" style="width: 80px;">
            <a :href="marunage.marunage_chat_url" target="_blank">
              <i v-if="marunage.marunage_chat.unread_count > 0" class="green large talk icon"></i>
              <i v-else class="large comment icon"></i>
            </a>
          </td>
          <td>
            {{ marunage.assignee_label }}
            <popup v-if="marunage.memo" :contents="marunage.memo">
              <i class="address card outline icon"></i>
            </popup>
          </td>
          <td>{{ marunage.status_label }}</td>
          <td>{{ marunage.code }}</td>
          <td>{{ marunage.request_count }} 件</td>
          <td>{{ marunage.tel }}</td>
          <td>{{ marunage.email }}</td>
          <td>{{ marunage.event_date | formatDate }} {{ marunage.event_time }}</td>
          <td>{{ marunage.name }}</td>
          <td>
            <div v-for="reservation in marunage.reservations">
              <a :href="reservation.banquet.chat_url" target="_blank" :title="reservation.banquet.shop.name">{{ reservation.id }}</a>
            </div>
          </td>
          <td>{{ marunage.device }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            searchForm: this.createForm(this.query()),
            pager: this.createPager(100, this.query().offset),
            marunages: [],
            downloadForm: this.createForm(),
            banquetsDownloadForm: this.createForm(),
        };
    },
    created: function() {
        this.search(this.pager.current());
    },
    computed: {
        marunageDownloadLink: function() {
            var baseUrl = '/afadmin/marunages/download?';
            var filters = [];
            if (this.downloadForm.model.begin) {
                filters.push('begin=' + moment(this.downloadForm.model.begin).format('YYYY-MM-DD'));
            }
            if (this.downloadForm.model.end) {
                filters.push('end=' + moment(this.downloadForm.model.end).format('YYYY-MM-DD'));
            }
            if (filters.length > 0) {
                baseUrl += filters.join('&');
            }
            return baseUrl;
        },
        banquetsDownloadLink: function() {
            const filters = [];
            if (this.banquetsDownloadForm.model.begin) {
                filters.push('begin=' + moment(this.banquetsDownloadForm.model.begin).format('YYYY-MM-DD'));
            }
            if (this.banquetsDownloadForm.model.end) {
                filters.push('end=' + moment(this.banquetsDownloadForm.model.end).format('YYYY-MM-DD'));
            }
            return '/afadmin/marunages/banquets/download?' + filters.join('&');
        }
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.searchForm.model, position);
            this.replaceStateQuery(this.searchForm.model, ['limit']);
            return this.searchForm.get('/afadmin/api/marunages', function(response) {
                this.marunages = response.data;
                this.pager.update(response.data, response);
            }.bind(this));
        },
        rowClass: function(marunage) {
            if (marunage.marunage_chat_comments.length < 2) {
                return 'new';
            } else if (!_.last(marunage.marunage_chat_comments).is_own) {
                return 'todo';
            }
            return null;
        },
        openDownloadDialog: function() {
            $('#show-download-dialog').modal('show');
        },
        openBanquetsDownloadDialog: function() {
            $('#show-banquets-download-dialog').modal('show');
        }
    }
};
</script>
